import { FC } from "react"


const Practices: FC = (): JSX.Element => {

  return (
    <div className="card p-0 d-flex flex-fill">
      <div className="card-header bg-success-subtle order-1 ">
        <h1 className="mb-0 p-0 text-start" style={{color: '#008853', fontSize: '1.875rem'}}>Practices</h1>
      </div>
      <div className="order-2 card-body p-0 overflow-y-auto" style={{maxHeight: 400}}>
        <h5 className="text-center">Coming Soon</h5>
      </div>
    </div>
  );
};
export default Practices;